export class FacilityPatientResultsSearchDto {
    PatientUid: string;
    SearchDateStart: Date;
    SearchDateEnd: Date;
}
